const Google = (() => {
	const default_config = {};
	const init = (obj) => {
		Object.assign(default_config, obj);
		if (!validateConfig()) return;
		onApiLoad();
	};

	const validateConfig = () => {
		if (!default_config.google.developer_key) {
			console.log("Developer key is required for google drive.");
			return false;
		}
		if (!default_config.google.client_id) {
			console.log("Client ID is required for google drive.");
			return false;
		}
		if (!default_config.google.scope) {
			console.log("Scope is required for google drive.");
			return false;
		}
		default_config.google.picker_api_loaded = false;
		return true;
	};

	function onApiLoad() {
		gapi.load('auth2', onAuthApiLoad);
		gapi.load('picker', onPickerApiLoad);
		// gapi.client.load('drive', 'v2', function() {});
	}
	function onAuthApiLoad() {
		const authBtn = document.getElementById('auth');
		authBtn.addEventListener('click', function() {
			gapi.auth2.init({ client_id: default_config.google.client_id }).then(function(googleAuth) {
				googleAuth.signIn({ scope: default_config.google.scope }).then(function(result) {
					handleAuthResult(result.getAuthResponse());
				})
			})
		});
	}
	function onPickerApiLoad() {
		default_config.google.picker_api_loaded = true;
		createPicker();
	}
	function handleAuthResult(auth_result) {
		if (auth_result && !auth_result.error) {
			default_config.google.oauth_token = auth_result.access_token;
			createPicker();
		}
	}
	function createPicker() {
		if (default_config.google.picker_api_loaded && default_config.google.oauth_token) {
			var view = new google.picker.View(google.picker.ViewId.DOCS);
			view.setMimeTypes("application/pdf");
			var picker = new google.picker.PickerBuilder()
				.enableFeature(google.picker.Feature.NAV_HIDDEN)
				.enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
				.setAppId(default_config.google.api_id)
				.setOAuthToken(default_config.google.oauth_token)
				.addView(view)
				.addView(new google.picker.DocsUploadView())
				.setDeveloperKey(default_config.google.developer_key)
				.setCallback(pickerCallback.bind(this))
				.build();
			picker.setVisible(true);
		}
	}
	function pickerCallback(data) {
		if (data.action === google.picker.Action.PICKED) {
			if (!data.docs || data.docs.length === 0) {
				console.log("No File Found");
				return;
			}
			for (let i = 0; i < data.docs.length; ++i) {
				const doc = data.docs[i];
				let fileId = doc.id;
				let name = doc.name;
				getFileFromDrive("https://www.googleapis.com/drive/v3/files/" + fileId + "?alt=media&key=cDnvCTAxa07WUNN9LEhw1NI2", name, default_config.google.oauth_token)
			}
		}
	}
	function getFileFromDrive(downloadUrl, fileName, token) {
		HttpRequest({
			method: "GET",
			url: downloadUrl,
			responseType: "blob",
			headers: {
				'Authorization': 'Bearer ' + token
			}
		}, function (u8arr) {
			let file;
			if (!navigator.msSaveBlob) { // detect if not Edge
				file = new File([u8arr], fileName, {
					type: 'application/pdf'
				});
			} else {
				let blob = new Blob([u8arr], {
					type: 'application/pdf'
				});
				file = blobToFile(blob, fileName);
			}
			yodleeManualScript.uploadFiles([file]);
		});
	}

	function  blobToFile(theBlob, fileName) {
		console.log(theBlob, fileName);
		const b = theBlob;
		b.lastModifiedDate = new Date();
		b.name = fileName;
		b.filename = fileName;
		return b;
	}
	return {
		init
	};
})();
